import getNotificatonsQuery from '../queries/getNotifications';

export default (apolloClient: any) => async () => {
  const { error, data } = await apolloClient.query({
    query: getNotificatonsQuery,
    fetchPolicy: 'network-only',
  });
  if (error) {
    throw error;
  }
  return data.notifications;
};
